/** @file variantMaskOf: the variant bit mask a drawable classifies with (host or its attachment's, 22.3). */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { PoseParams } from '@zilo/pose3d-pose/contract';
import { attachmentIndexOf } from '@zilo/pose3d-pose/attach/attachmentIndexOf';

/**
 * CR-006 (22.3): a flattened drawable `att<i>.<name>` of `puppet.attachments[i]` uses
 * `params.attachmentVariants[attachment.id]` when that id has an entry (0 included), so a weapon's variant does not
 * select the host's; every other drawable, and an attachment without an entry, uses `params.variantMask` (absent = 0).
 */
export function variantMaskOf(puppet: Pick<Puppet, 'attachments'>, drawableId: string,
  params: Pick<PoseParams, 'variantMask' | 'attachmentVariants'>): number {
  const host = params.variantMask ?? 0;
  const masks = params.attachmentVariants;
  if (masks === undefined) return host;
  const i = attachmentIndexOf(drawableId);
  const id = i < 0 ? undefined : puppet.attachments?.[i]?.id;
  return id !== undefined && Object.hasOwn(masks, id) ? (masks[id] ?? host) : host;
}
